import './PrintCheck.css';

export default function PrintCheck() {
    
    const fromBlock = <div>
        <b>Elon Musk</b><br />
        13101 Tesla Road<br />
        Austin, TX 78725 
    </div>

    const bankLogo = <img
        alt="Citizens Bank Logo"
        height="50" 
        src="data:image/png;base64,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"
    />

    const bankBlock = <div>
        Citizens Bank N.A.<br />
        814 Main Street<br />
        Stroudsburg, PA 18360<br />
        (570) 424-7197
    </div>

    const checkNumber = '301'

    const abaFraction = '3-7615 / 360'

    const paddedCheckNumber = '0000000301'

    const bankRoutingNumber = '036076150'

    const bankAccountNumber = '6318100001'

    return (
        <div className="check-wrapper">
            <div className="outer">
                <div className="check">
                    <div className="top-row">
                        <div className="from-block">
                            {fromBlock}
                        </div>
                        <div className="bank-logo">
                            {bankLogo}
                        </div>
                        <div className="bank-block">
                            {bankBlock}
                        </div>
                        <div className="check-number">
                            {checkNumber}
                        </div>
                        <div className="aba-fraction">
                            {abaFraction}
                        </div>
                        <div className="check-date">
                            Date ___________________
                        </div>
                    </div>
                    <div className="middle-row">
                        <div className="payto-label">
                            Pay To The<br />
                            Order Of
                        </div>
                        <div className="payee-name">
                            <br />
                            _________________________________________________________________
                        </div>
                        <div className="dollar-sign-label">
                            <br />
                            $
                        </div>
                        <div className="amount-numeric">
                            <br />
                            ______________________
                        </div>
                        <div className="amount-written">
                            <br />
                            _____________________________________________________________________________________
                        </div>
                        <div className="dollars-label">
                            <br />
                            Dollars
                        </div>
                    </div>
                    <div className="third-row">
                        <div className="memo-label">
                            Memo
                        </div>
                        <div className="memo-block">
                            ________________________________________
                        </div>
                        <div className="signature-block">
                            ___________________________________________
                        </div>
                        <div className="signature-label">
                            Authorized Signature
                        </div>
                    </div>
                    <div className="micr-area">
                        C{paddedCheckNumber}C  A{bankRoutingNumber}A {bankAccountNumber}C
                    </div>
                </div>
            </div>
        </div>
    );
}

